import React from "react";
import PageWrapper from "../components/PageWrapper";
import ContactForm from "../components/ContactForm";
import styled from "styled-components";
import SEO from "../components/SEO";
import { settings } from "../data/settings";

const Title = styled.div`
  font-size: 2.2rem;
  font-weight: 800;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
`;
const PageContact = () => {
  return (
    <PageWrapper style={{ backgroundColor: "#fff", color: "#000" }}>
      <SEO pageKey="contact" />
      <div style={{ maxWidth: 600, margin: "0 auto", padding: "2rem" }}>
        <Title>Contactez-nous</Title>
        <ContactForm />
      </div>
    </PageWrapper>
  );
};

export default PageContact;
